import { useState, useCallback, useRef } from "react";

/**
 * @param {string} key - Storage key
 * @param {*} initialValue - Default value if key not found
 * @param {Storage} [storage=localStorage] - Storage backend (pass sessionStorage for demo/practice)
 */
export const useExamStorage = (key, initialValue, storage = localStorage) => {
    const storageRef = useRef(storage);

    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = storageRef.current.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error("Error reading storage key:", key, error);
            return initialValue;
        }
    });

    const valueRef = useRef(storedValue);
    valueRef.current = storedValue;

    const setValue = useCallback((value) => {
        try {
            const valueToStore =
                value instanceof Function ? value(valueRef.current) : value;
            valueRef.current = valueToStore;
            setStoredValue(valueToStore);
            storageRef.current.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error("Error setting storage key:", key, error);
        }
    }, [key]);

    return [storedValue, setValue];
};
